import React from "react";

const AnalyticsSubHeader = ({ activeSubTab = "overview", setActiveSubTab }) => {
  const subTabs = [
    { id: "overview", label: "Overview" },
    { id: "ttt", label: "Text-to-Text" },
    { id: "tts", label: "Text-to-Speech" },
    { id: "stt", label: "Speech-to-Text" },
    { id: "sts", label: "Speech Translations" },
  ];

  return (
    <div className="border-b border-gray-200 -mx-4 md:-mx-6 px-4 md:px-6 my-6">
      <nav className="flex items-center justify-between overflow-x-auto no-scrollbar w-full">
        {subTabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveSubTab(tab.id)}
            className={`pb-3 text-sm font-extrabold whitespace-nowrap transition-all duration-200 border-b-3 -mb-px ${activeSubTab === tab.id
                ? "border-[#1e6c56] text-gray-950 font-black"
                : "border-transparent text-gray-800 hover:text-gray-950 font-bold"
              }`}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default AnalyticsSubHeader;
